export enum EOrderCreatedStatus {
  Success = 'success',
  Rejected = 'rejected',
}
